import { useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { CampoNumero, CampoSelect, Resultado, Rejilla } from "../components/campos.jsx";
import { convertirMedida } from "../lib/calc.js";
import { CATEGORIAS_MEDIDA } from "../data/medidas.js";

export default function Medidas() {
  const [clave, setClave] = useState("length");
  const [valor, setValor] = useState(1);
  const [desde, setDesde] = useState("m");
  const [hacia, setHacia] = useState("ft");

  const categoria = CATEGORIAS_MEDIDA[clave];
  const resultado = convertirMedida(valor, desde, hacia, categoria);

  function cambiarCategoria(k) {
    setClave(k);
    const u = CATEGORIAS_MEDIDA[k].units;
    setDesde(u[0].value);
    setHacia(u[1]?.value ?? u[0].value);
  }

  const opciones = categoria.units.map((u) => ({ valor: u.value, etiqueta: u.label }));

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap gap-2">
        {Object.entries(CATEGORIAS_MEDIDA).map(([k, c]) => (
          <button
            key={k}
            onClick={() => cambiarCategoria(k)}
            aria-pressed={clave === k}
            className={`rounded-full border px-3.5 py-1.5 text-sm transition ${
              clave === k
                ? "border-[color:var(--color-marca-300)] bg-[color:var(--acento)] font-semibold text-white"
                : "borde texto-2 hover:text-[color:var(--texto)]"
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>

      <Rejilla cols="lg:grid-cols-2">
        <div className="space-y-4">
          <CampoNumero label="Cantidad" valor={valor} onChange={setValor} />
          <CampoSelect label="De (origen)" valor={desde} onChange={setDesde} opciones={opciones} />

          <button
            onClick={() => {
              setDesde(hacia);
              setHacia(desde);
            }}
            className="boton boton-suave"
          >
            <ArrowLeftRight className="h-3.5 w-3.5" aria-hidden="true" />
            Invertir unidades
          </button>

          <CampoSelect label="A (destino)" valor={hacia} onChange={setHacia} opciones={opciones} />
        </div>

        <div>
          <Resultado
            label="Resultado"
            valor={`${resultado.toLocaleString("es-MX", { maximumFractionDigits: 6 })} ${hacia}`}
            nota={`${valor.toLocaleString("es-MX")} ${desde} = ${resultado.toLocaleString("es-MX", { maximumFractionDigits: 6 })} ${hacia}`}
          />
        </div>
      </Rejilla>
    </div>
  );
}
